import {classNames} from "shared/lib/classNames/classNames";
//import {ReactComponent as Logo} from "shared/assets/icons/AvalornFooterLogo.svg";
import cls from "./Footer.module.scss";
import {AppLink} from "shared/ui/AppLink/AppLink";
import {useState} from "react";
import Socials from "shared/ui/Socials/Socials";
import Modal from "shared/ui/Modal/Modal";
import {Cookie} from "widgets/Cookie";

interface FooterProps {
    className?: string
}

export const Footer = ({className}: FooterProps) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={classNames(cls.Footer, {}, [className])}>
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
                <Cookie onAccept={() => setIsOpen(false)} onDecline={() => setIsOpen(false)}/>
            </Modal>
            <div className={classNames("container container__main")}>
                <div className={cls.Footer__logo}>

                </div>

                <div className={cls.Footer__social}>
                    <div className={cls.Privacy}>
                        <AppLink to={"/privacy-policy"} className={cls.Privacy__link}>
                            Privacy Policy
                        </AppLink>
                        <span className={classNames(cls.Privacy__link, {}, [cls.Privacy__link_cookie])}
                            onClick={() => setIsOpen(true)}>
                            Cookie Policy
                        </span>
                        <AppLink to={"/terms"} className={cls.Privacy__link}>
                            Terms of Service
                        </AppLink>
                    </div>

                    <Socials className={cls.Footer__socials}/>
                </div>
            </div>

            <div className={cls.Footer__divider}/>

            <div className={classNames("container container__main")}>
                <div className={cls.Footer__rights}>
                    © 2023-2025 Traffic Heroes Ltd. All rights reserved.
                </div>
            </div>
        </div>
    )
};
